import {
  VENDOR_PROFILE_DETAILS_REQUEST, VENDOR_PROFILE_DETAILS_FAIL, VENDOR_PROFILE_DETAILS_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: true,
  action: "Home Action",
  result: [],
  msg: "",
  error: "",
};

const VendorProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_PROFILE_DETAILS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case VENDOR_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case VENDOR_PROFILE_DETAILS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default VendorProfileReducer;
